import moment from 'moment';

export const ESTADO_PENDIENTE = 1;
export const ESTADO_EN_REVISION = 2;
export const ESTADO_ACEPTADA = 3;
export const ESTADO_RECHAZADA = 4;
export const ESTADO_EN_FINANZAS = 5;
export const ESTADO_MAS_INFORMACION = 6;
export const ESTADO_FINALIZADA = 7;

export const PAGE_SIZE = 15;

export const ESTADO_CHIP_STYLES = {
    [ESTADO_PENDIENTE]: { backgroundColor: '#fff3cd', color: '#856404' },
    [ESTADO_EN_REVISION]: { backgroundColor: '#cfe2ff', color: '#084298' },
    [ESTADO_EN_FINANZAS]: { backgroundColor: '#e8d5f5', color: '#5a0080' },
    [ESTADO_MAS_INFORMACION]: { backgroundColor: '#f8d7da', color: '#842029' },
    [ESTADO_FINALIZADA]: { backgroundColor: '#d1e7dd', color: '#0a3622' },
    default: { backgroundColor: '#f0e5dd', color: '#2b180b' },
};

export function getEstadoChipStyle(estadoId) {
    const id = Number(estadoId);
    return ESTADO_CHIP_STYLES[id] ?? ESTADO_CHIP_STYLES.default;
}

export function getDetalleModalTitle(estadoId, intent = 'ver') {
    const id = Number(estadoId);
    if (id === ESTADO_MAS_INFORMACION && intent === 'aportar') {
        return 'Aportar información';
    }
    if (id === ESTADO_EN_FINANZAS) {
        return 'Gestión en finanzas';
    }
    return 'Detalle de la solicitud';
}

export const SECTION_TITLE_STYLE = {
    color: '#215732',
    fontSize: '0.78rem',
    letterSpacing: '0.07em',
};

export const SECTION_CARD_STYLE = { backgroundColor: '#f8f9fa' };

export const WARNING_NOTICE_STYLE = {
    backgroundColor: '#fff3cd',
    color: '#856404',
    fontSize: '13px',
};

export const MODAL_LOADER_COLOR = '#215732';

export const TOAST_FINANZAS_DETALLE_LOAD_ERROR =
    'No se han podido cargar los datos de finanzas.';

export const getEstadoId = (item) =>
    Number(item?.estado?.id ?? item?.estado_id) || null;

export const normalizePiezas = (source) =>
    source?.piezas?.length ? source.piezas : [];

const parseFecha = (fecha) => {
    if (!fecha) return null;
    const parsed = moment(fecha);
    return parsed.isValid() ? parsed : null;
};

export const formatFecha = (fecha) => {
    const parsed = parseFecha(fecha);
    return parsed ? parsed.format('DD/MM/YYYY') : '-';
};

export const formatFechaHora = (fecha) => {
    const parsed = parseFecha(fecha);
    if (!parsed) return '-';

    const soloFecha =
        typeof fecha === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(fecha.trim());

    if (soloFecha) {
        return parsed.format('DD/MM/YYYY');
    }

    return parsed.format('DD/MM/YYYY HH:mm');
};

export const formatPrecio = (valor) =>
    valor != null && valor !== '' ? `${Number(valor).toFixed(2)}€` : '-';

export const sumPrecioVentaPiezas = (piezas = []) =>
    Number(piezas.reduce((acc, pieza) => acc + (Number(pieza?.precio_venta) || 0), 0).toFixed(2));

export const formatUsuarioDisplay = (usuario) => {
    if (usuario == null || usuario === '') {
        return 'Usuario';
    }

    const trimmed = String(usuario).trim();
    if (!trimmed) {
        return 'Usuario';
    }
    if (trimmed === '-') {
        return '-';
    }
    if (trimmed.toLowerCase() === 'landing') {
        return 'Desguace';
    }

    return trimmed
        .split(/\s+/)
        .filter(Boolean)
        .map(
            (part) =>
                part.charAt(0).toUpperCase() + part.slice(1).toLowerCase(),
        )
        .join(' ');
};
